import React from 'react';
import Chunk from 'components/Chunk';

const loadCheckoutContainer = () =>
  import('./containers' /* webpackChunkName: "checkout" */ /* webpackPreload: true */);

const Checkout = () => <Chunk load={loadCheckoutContainer} />;

export default Checkout;
